<template>
  <div id="tab">
    <el-card class="box-card" shadow="never">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-button type="success" @click="dialogTableVisible = true">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="deletePricePlan()">批量删除</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="table">
      <el-table ref="table" row-key="id" v-loading="tableIsLoading" :data="tableList" border stripe height="100%" max-height="100%" size="mini">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column type="selection" width="50" reserve-selection :selectable="selectable"></el-table-column>
        <el-table-column label="价格方案" prop="planDesc" width="200"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <el-link size="small" icon="el-icon-edit" @click="editPricePlan(row)"></el-link>
            <el-link v-if="row.isDefine == 'N'" size="small" icon="el-icon-delete" @click="deletePricePlan(row)" style="margin-left: 12px;"></el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="isEdit ? '编辑价格方案' : '新增价格方案'" :visible.sync="dialogTableVisible" @close="dialogClose">
      <el-form label-width="60px">
        <el-form-item label="名称">
          <el-input v-model="activeTableRow.planDesc" placeholder="请输入价格方案名称"></el-input>
        </el-form-item>
      </el-form>
      <el-form slot="footer" :inline="true" size="small">
        <el-form-item>
          <el-button type="primary" @click="addPricePlan(false)">保存</el-button>
        </el-form-item>
        <el-form-item v-if="!isEdit">
          <el-button @click="addPricePlan(true)">保存并新建</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogTableVisible = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableIsLoading: false,
      dialogTableVisible: false,
      tableList: [],
      activeTableRow: {
        planDesc: ''
      },
      isEdit: false
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList() {
      this.tableIsLoading = true
      const { data: res } = await this.$http.post('/Account/PricePlan/selectPricePlanListVue.html')
      if (res.code != "success") return this.$message.error(res.message);
      this.tableIsLoading = false
      res.result = JSON.parse(res.result);
      this.tableList = JSON.parse(res.result.data);
    },
    dialogClose() {
      this.activeTableRow = {
        planDesc: ''
      }
      this.isEdit = false
    },
    async addPricePlan(isNew) {
      if (!this.activeTableRow.planDesc) return this.$message.error('请输入价格方案名称')
      const loading = this.$loading({
        lock: true,
        text: '保存中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let url = '/Account/PricePlan/addPricePlanVue.html'
      if (this.isEdit) {
        url = '/Account/PricePlan/updatePricePlanVue.html'
      }
      const { data: res } = await this.$http.post(url, this.Qs.stringify(this.activeTableRow))
      loading.close();
      if (res.code != "success") return this.$message.error(res.message);
      this.$message.success(res.message)
      if (!isNew) {
        this.dialogTableVisible = false
      } else {
        this.dialogClose()
      }
      this.getTableList()
    },
    editPricePlan(row) {
      this.isEdit = true
      this.activeTableRow = {...row}
      this.dialogTableVisible = true
    },
    selectable(row) {
      if (row.isDefine == 'N') {
        return true
      } else {
        return false
      }
    },
    async deletePricePlan(row) {
      let id = ''
      if (row) {
        id = row.id
      } else {
        let selection = this.$refs.table.selection
        if (selection.length == 0) {
          return this.$message.warning('请至少选中一个价格方案')
        }
        id = selection.map(i => "'" + i.id + "'").join(',')
      }
      console.log(id)
      const { data: res } = await this.$http.post('/Account/PricePlan/deletePricePlanVue.html', this.Qs.stringify({id}))
      if (res.code != "success") return this.$message.error(res.message);
      this.$message.success(res.message)
      this.getTableList()
    }
  }
}
</script>

<style scoped lang="less">
#tab {
  ::v-deep .box-card {
    .el-card__body {
      padding: 10px 15px;
      .el-form {
        .el-form-item {
          margin-bottom: 0;
        }
      }
    }
  }
  .table {
    height: calc(100% - 53px);
  }
}
</style>